import { DateTime } from 'luxon';

/**
 * Returns a string in a format like 'Oct 13, 1994'
 * @param {string} isoDate ISO 8601 string.
 */
export default function (isoDate) {
  return `${DateTime.fromISO(isoDate).toLocaleString(DateTime.DATE_MED)}`;
}
